import * as React from "react";

import { ListResultsMeta } from "services/api/shared";
import { ListFiltersState } from "utils/hooks/useListFilters";
import useListSelection from "utils/hooks/useListSelection";
import { UserItem as UserItemType } from "modules/users/provider/users";
import { AutoGrid } from "components";

import DirectUserTable from "./direct-user-list";
import DirectUserListPagination from "./direct-user-list-pagination";
import DirectUserListSubActions from "./direct-user-list-sub-actions";
import DirectUserListToolbar from "./direct-user-list-toolbar";

type UsersListContainerProps = {
  users: UserItemType[];
  meta: ListResultsMeta;
  listFilters: ListFiltersState;
  refetch: () => void;
  companyId?: string;
  loading: boolean;
};

const DirectUserListContainer: React.FC<UsersListContainerProps> = ({
  users,
  meta,
  listFilters,
  refetch,
  loading
}) => {
  const listSelection = useListSelection(users);
  const selectedUserIds = listSelection.actions.getSingleField("id");
  const clearSelection = () => listSelection.actions.unselectAll();
  return (
    <>
      <DirectUserListToolbar listFilters={listFilters} />
      <DirectUserTable
        {...{ users, loading, refetch, listSelection, listFilters }}
      />
      <AutoGrid justify="space-between" showEmpty>
        <DirectUserListSubActions
          {...{ refetch, selectedUserIds, clearSelection }}
        />
        <DirectUserListPagination {...{ meta, listFilters }} />
      </AutoGrid>
    </>
  );
};

export default DirectUserListContainer;
